<template>
  <div id="modal">
    <b-modal
      :size="size"
      no-close-on-esc
      hide-footer
      centered
      v-model="visible"
      :header-close-content="customModalData.headerCloseLabel"
      content-class="style"
      header-close-variant="dark"
      direction="rtl"
      :header-border-variant="customModalData.headerBorderVariant"
      :footer-border-variant="customModalData.footerBorderVariant"
    >
      <!-- @change="toggle" -->
      <template #modal-title>
        {{ bModalTitle }}
      </template>
      <slot></slot>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      customModalData: {
        headerCloseLabel: 'x',
        headerBorderVariant: '1',
        footerBorderVariant: '1',
      },
    }
  },
  props: {
    bModalTitle: {
      default: 'modal',
    },
    size: {
      type: String,
      default: 'xl',
    },
    visible: {
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .modal-backdrop {
  background-color: rgba(3, 31, 74, 0.24);
}
::v-deep hr {
  display: none;
}

::v-deep .style {
  background: #ffffff;
  border: 2px solid #ffffff;
  box-sizing: border-box;
  box-shadow: 0px 4px 10px rgba(93, 78, 123, 0.1),
    inset 0px 0px 6px rgba(93, 78, 123, 0.1);
  border-radius: 16px;
}

::v-deep .modal-header {
  // border: none;
  justify-content: flex-end !important;
}

::v-deep .modal-header .close,
::v-deep .alert .close {
  font-size: 20px !important;
}
::v-deep .modal-title {
  font-weight: 500;
}

::v-deep .close {
  position: absolute;
  left: 0;
}
</style>
